import { Injectable } from '@angular/core';
import { ChartjsGraphsService as DataVizService } from "../../shared/graphs/chartjs-graphs/chartjs-graphs.service";

@Injectable()
export class ChartjsService {
  constructor(
    public dataVizService: DataVizService,
  ) { }

  /**
   * **Intialize the chart with some arguments**
   * @param renderElement string
   * @param dataSet any
   */
  public drawChart(renderElement: string, data: any) {
    return this.dataVizService.init(renderElement, data);
  }

  /**
   * updateChartData
   */
  public updateChartData(data: any) {
    this.dataVizService.update(data);
  }

  /**
   * drawNewChart
   */
  public newChartDraw(chart, data: any) {
    return this.dataVizService.newChartDraw(chart, data);
  }

  /**
  * formatChartData
  */
  public formatChartData(insightData: any, configOptions: any) {
    return this.formatDynamicChartsData(insightData, configOptions);
  }

  /**
   * formatExecutiveSummaryData
   */
  public formatExecutiveSummaryData(insightData: any, configOptions: any) {
    return this.formatExecutiveSummaryDynamicChartsData(insightData, configOptions);
  }

  private formatDynamicChartsData(insightData: any, configOptions: any) {
    let formattedData: object = {};
    if (insightData && configOptions) {
      switch (insightData.chartType.toLowerCase()) {
        case 'doughnut':
          formattedData = this.formatDoughnutChartData(insightData, configOptions);
          break;
       default:
          formattedData;
          break;
      }
    }
    return formattedData;
  }

  private formatExecutiveSummaryDynamicChartsData(insightData: any, configOptions: any) {
    let formattedData: object = {};
    if (insightData && configOptions) {
      switch (insightData.chartType.toLowerCase()) {
        case 'doughnut':
          formattedData = this.formatExecutiveSummaryDoughnutChartData(insightData, configOptions);
          break;
        default:
          formattedData;
          break;
      }
    }
    return formattedData;
  }

  private formatDoughnutChartData(insightData: any, configOptions: any) {
    let dataSetsData = [];
    let chartData = insightData;
    if (chartData.data === null) {
      return;
    }
    for (let i = 0; i < chartData.data.length; i++) {
      let color = this.updateSpitter('#00FF00', '#00AAFF', chartData.data[i].length);
      dataSetsData.push(
        {
          fill: true,
          borderWidth: 2,
          data: chartData.data[i],
          borderColor: 'rgba(0, 0, 0, 0.1)',
          backgroundColor: color
        }
      )
    }
    let formattedData = {
      datasets: dataSetsData,
      type: insightData.chartType,
      labels: insightData.labels,
      options: {
        title: {
          display: true,
          text: insightData.ruleDisplayName ? insightData.ruleDisplayName : '',
          ruleName: insightData.ruleName
        },
        animation: {
          duration: 0
        },
        legend: {
          display: configOptions.showLabels ? true : false
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          intersect: true,
          titleFontSize: 9,
          bodyFontSize: 9
        },
        // onClick: function(evt) {
        //   let chartEl = document.getElementById(`${evt.canvas.id}`);
        // var element = chartEl.getElementAtEvent(evt);
        // if(element.length > 0)
        // {
        // var ind = element[0]._index;
        // if(confirm('Do you want to remove this point?')){
        //   data.datasets[0].data.splice(ind, 1);
        //   data.labels.splice(ind, 1);
        //   chartEl.update(data);
        // }
        // }
        // }
      }
    };
    return formattedData;
  }

  private formatExecutiveSummaryDoughnutChartData(insightData: any, configOptions: any) {
    let dataSetsData = [];
    let chartData = insightData;
    if (chartData.data === null) {
      return;
    }
    let colors = ["#008000", "#FF0000", "#f16e02", "#6f87d8"]
    for (let i = 0; i < chartData.data.length; i++) {
      dataSetsData.push(
        {
          fill: true,
          borderWidth: 0,
          // borderColor: '#000',
          data: chartData.data[i],
          backgroundColor: colors
        }
      )
    }
    let formattedData = {
      datasets: dataSetsData,
      type: insightData.chartType,
      labels: insightData.labels,
      options: {
        elements: {
          arc: {
            roundedCornersFor: 3
          },
        },
        title: {
          display: false,
          text: insightData.ruleDisplayName ? insightData.ruleDisplayName : '',
          ruleName: insightData.ruleName
        },
        cutoutPercentage: 83,
        animation: {
          duration: 0
        },
        layout: {
          padding: 20
        },
        legend: {
          display: true,
          position: 'right',
          align: 'middle',
          labels: {
            usePointStyle: true,
            fontSize: 11,
            fontFamily: "Work Sans",
            boxWidth: 8,
            fontColor: "#fff",
            generateLabels: function (chart: any) {
              var data = chart.data;
              if (data.labels.length && data.datasets.length) {
                return data.labels.map(function (label: string, i: number) {
                  var meta = chart.getDatasetMeta(0);
                  var ds = data.datasets[0];
                  var arc = meta.data[i];
                  var custom = (arc && arc.custom) || {};
                  var arcOpts = chart.options.elements.arc;
                  var fill = custom.backgroundColor
                    ? custom.backgroundColor
                    : ds.backgroundColor[i];
                  var stroke = custom.borderColor
                    ? custom.borderColor
                    : ds.backgroundColor[i];
                  var bw = custom.borderWidth ? custom.borderWidth : 2;
  
                  // We get the value of the current label
                  var value = chart.config.data.datasets[0].data[i];
                  let legendValue =
                    value <= 100
                      ? value
                      : value <= 99999
                        ? value / 1e3
                        : value >= 100000
                          ? value / 1e6
                          : value;
                  legendValue = (
                    Math.floor(legendValue * 100) / 100
                  ).toString();
                  let legendSign =
                    value <= 100
                      ? ''
                      : value <= 99999
                        ? 'K'
                        : value >= 100000
                          ? 'M'
                          : '';
                  let displayValue =
                    legendValue.split('.')[1] === '00'
                      ? legendValue.split('.')[0]
                      : legendValue;
                  return {
                    // Instead of `text: label,`
                    // We add the value to the string
                    text: label + ' ' + '('+displayValue + legendSign+')',
                    fillStyle: fill,
                    strokeStyle: stroke,
                    lineWidth: bw,
                    hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                    index: i,
                  };
                });
              } else {
                return [];
              }
            }
          },
          
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          intersect: true,
          titleFontSize: 9,
          bodyFontSize: 9,
          callbacks: {
            label: function (tooltipItem, data) {
              let sum = 0;

              var allData = data.datasets[tooltipItem.datasetIndex].data;
              allData.map(data => {
                sum += data;
              });
              var tooltipLabel = data.labels[tooltipItem.index];
              var tooltipData = allData[tooltipItem.index];
              let percentage = (allData[tooltipItem.index]*100 / sum).toFixed(2)+"%";
              return tooltipLabel + ": " + tooltipData + "(" +percentage + ")";
            }
          }
        }
      },
      plugins: [{
        // afterUpdate: function (chart) {
        //   if (chart.config.options.elements.arc.roundedCornersFor !== undefined) {
        //     var arc = chart.getDatasetMeta(0).data[chart.config.options.elements.arc.roundedCornersFor];
        //     arc.round = {
        //       x: (chart.chartArea.left + chart.chartArea.right) / 2,
        //       y: (chart.chartArea.top + chart.chartArea.bottom) / 2,
        //       radius: (chart.outerRadius + chart.innerRadius) / 2,
        //       thickness: (chart.outerRadius - chart.innerRadius) / 2 - 1,
        //       backgroundColor: arc._model.backgroundColor
        //     }
        //   }
        // },

        // afterDraw: function (chart) {
        //   if (chart.config.options.elements.arc.roundedCornersFor !== undefined) {
        //     var ctx = chart.chart.ctx;
        //     var arc = chart.getDatasetMeta(0).data[chart.config.options.elements.arc.roundedCornersFor];
        //     var startAngle = Math.PI / 2 - arc._view.startAngle;
        //     var endAngle = Math.PI / 2 - arc._view.endAngle;

        //     ctx.save();
        //     ctx.translate(arc.round.x, arc.round.y);
        //     console.log(arc.round.startAngle)
        //     ctx.fillStyle = arc.round.backgroundColor;
        //     ctx.beginPath();
        //     ctx.arc(arc.round.radius * Math.sin(startAngle), arc.round.radius * Math.cos(startAngle), arc.round.thickness, 0, 2 * Math.PI);
        //     ctx.arc(arc.round.radius * Math.sin(endAngle), arc.round.radius * Math.cos(endAngle), arc.round.thickness, 0, 2 * Math.PI);
        //     ctx.closePath();
        //     ctx.fill();
        //     ctx.restore();
        //   }
        // },
      }]
    };
    return formattedData;
  }

  public updateSpitter(color1, color2, steps) {
    //attach start value
    let c1: number = this.getType(color1);
    let c2: number = this.getType(color2);
    let val1RGB = this.processValue(c1, color1);
    let val2RGB = this.processValue(c2, color2);
    let colors = [
      // somewhere to dump gradient
    ];

    //the number of steps in the gradient
    let stepsInt = parseInt(steps, 10);
    //the percentage representation of the step
    let stepsPerc = 100 / (stepsInt + 1);

    // diffs between two values
    let valClampRGB = [
      val2RGB[0] - val1RGB[0],
      val2RGB[1] - val1RGB[1],
      val2RGB[2] - val1RGB[2]
    ];

    // build the color array out with color steps
    for (let i = 0; i < stepsInt; i++) {
      let clampedR = (valClampRGB[0] > 0)
        ? this.pad((Math.round(valClampRGB[0] / 100 * (stepsPerc * (i + 1)))).toString(16), 2)
        : this.pad((Math.round((val1RGB[0] + (valClampRGB[0]) / 100 * (stepsPerc * (i + 1))))).toString(16), 2);

      let clampedG = (valClampRGB[1] > 0)
        ? this.pad((Math.round(valClampRGB[1] / 100 * (stepsPerc * (i + 1)))).toString(16), 2)
        : this.pad((Math.round((val1RGB[1] + (valClampRGB[1]) / 100 * (stepsPerc * (i + 1))))).toString(16), 2);

      let clampedB = (valClampRGB[2] > 0)
        ? this.pad((Math.round(valClampRGB[2] / 100 * (stepsPerc * (i + 1)))).toString(16), 2)
        : this.pad((Math.round((val1RGB[2] + (valClampRGB[2]) / 100 * (stepsPerc * (i + 1))))).toString(16), 2);
      colors[i] = [
        '#',
        clampedR,
        clampedG,
        clampedB
      ].join('');
    }
    return colors;
  }

  // get the string representation
  // type and set it on the element (HEX/RGB/RGBA)
  private getType(val) {
    if (val.indexOf('#') > -1) return 1;
    if (val.indexOf('rgb(') > -1) return 2;
    if (val.indexOf('rgba(') > -1) return 3;
  }

  private processValue(value, color) {
    switch (value) {
      case 1:
        {
          return this.processHEX(color);
        }
      case 2: {
        return this.processRGB(color);
      }
      case 3: {
        return this.processRGB(color);
      }

    }
  }

  //return a workable RGB int array [r,g,b] from rgb/rgba representation
  private processRGB(val) {
    let rgb = val.split('(')[1].split(')')[0].split(',');
    alert(rgb.toString());
    return [
      parseInt(rgb[0], 10),
      parseInt(rgb[1], 10),
      parseInt(rgb[2], 10)
    ];
  }

  //return a workable RGB int array [r,g,b] from hex representation
  private processHEX(val) {
    //does the hex contain extra char?
    let hex = (val.length > 6) ? val.substr(1, val.length - 1) : val;
    // is it a six character hex?
    let r, g, b;
    if (hex.length > 3) {

      //scrape out the numerics
      r = hex.substr(0, 2);
      g = hex.substr(2, 2);
      b = hex.substr(4, 2);

      // if not six character hex,
      // then work as if its a three character hex
    } else {

      // just concat the pieces with themselves
      r = hex.substr(0, 1) + hex.substr(0, 1);
      g = hex.substr(1, 1) + hex.substr(1, 1);
      b = hex.substr(2, 1) + hex.substr(2, 1);
    }
    // return our clean values
    return [
      parseInt(r, 16),
      parseInt(g, 16),
      parseInt(b, 16)
    ]
  }

  private pad(n, width, z?) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }
}
